import React, {useCallback} from "react";
import { usePosterSizesQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";
import {GraphQlSelect} from "./GraphQlSelect";
import {useDaybookContext} from "../../contexts/Daybook/DayBookContext";

export function PosterSizeSelect(props) {
    const rp = useDaybookContext();
    const query = usePosterSizesQueryQuery({
        variables: {
            regionPricing: rp?.regionAreaBookingPricing??false
        } as any
    });
    const filterOptions = useCallback((options) => {
        const prefix = props.values?.salesTeam?.prefix;
    
        return options.filter((element) => {
            const isLocalSpecial = ["A 4 Sheet (Local)", "A Quad (Local)", "A 4 Sheet (GD)"].includes(element.name);
            
            if (isLocalSpecial && prefix) {
                return prefix === "JAR" || prefix === "BHS";
            }
            
            return (
                (props.isPanelPoster && element.is_panel_poster) ||
                (props.isStreetPoster && element.is_street_poster) ||
                (props.isMediaType && element.is_media_type) ||
                props.isAll
            );
        });
    }, [
        props.isPanelPoster,
        props.isStreetPoster,
        props.isMediaType,
        props.isAll,
        props.values?.salesTeam?.prefix
    ]);
    
    const onChange = function(evt) {
        if(props.saveFields) {
            const val = evt.target.value;
            const newValue = {};
            props.saveFields.forEach((k)=>{
                newValue[k] = val[k];
            });
            evt.target.value = newValue;
            props.onChange(evt);
            return;
        }
        props.onChange(evt);
    }

    return props.valueIsId?<GraphQlSelectId filterOptions={filterOptions} queryResult={query} {...props}  labelField={props.showCustomerName?'customer_name':'name'}/>:
        <GraphQlSelect queryResult={query} filterOptions={filterOptions} {...props}  labelField={props.showCustomerName?'customer_name':'name'} onChange={onChange} />;
}

